<template>
    <div >
        <img :src="require('@/assets/img/case/banner.jpg')" alt="" style="width: 100%" data-aos="zoom-out">
        <div class="customer" data-aos="fade-up">
            <div></div>
            <div>{{customer[customerIndex].content}}</div>
        </div>
<!--        <case-menu @caseSelect="caseSelect"></case-menu>-->
        <router-view @caseSelect="caseSelect"></router-view>
    </div>
</template>

<script>
import WOW from '../../node_modules/wowjs/dist/wow';
import CaseMenu from "../components/CaseMenu";
export default {
	components: {
	    CaseMenu
    },
	data() {
		return {
            customer:[
                {
                    id:'hospital',
                    content:'公司核心团队历经十余年深耕，依托精准医学领域行业先发优势，自主打造“精准医学大数据平台”系列产品，已在国内 300 余家三甲医院、高等院校、科研院所及生物医药企业完成落地实施。代表客户包括：中国人民解放军总医院、复旦大学（附属17家医院，16个二级学院及研究院)、中山大学(附属3家医院)、天津医科大学（附属5家医院)、南方医科大学南方医院、东方肝胆外科医院、中国食品药品检定研究院、 上海生物样本库（原“上海张江生物银行”）、武汉协和医院等。'
                },
                {
                    id:'institution',
                    content:''
                },
                {
                    id:'company',
                    content:''
                }
            ],
            customerIndex:0
        }
	},
	mounted(){
        let wow = new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
        // this.$router.push({
		// 	path:'/case/hospital'
		// })
	},
    methods:{
        caseSelect(src){
	        if (src.indexOf('/img') > -1){
	            return
            }
            this.$router.push({
                path:src
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .customer{
        width: 100%;
        height: 252px;
        padding: 79px 25% 0;
        margin-top: -3.5px;
        box-sizing: border-box;
        background: url("../assets/img/case/caseCustomer.png") no-repeat;
        position: relative;
        &>div:nth-child(1){
            width: 62px;
            height: 62px;
            border-radius: 50%;
            background: #fff;
            position: absolute;
            top: -31px;
            left: calc(50% - 31px);
        }
        &>div:nth-child(1):after,&>div:nth-child(1):before{
            display: block;
            content: '';
            position: absolute;
            left: 18px;
            top: 31px;
            width: 0;
            height:0;
            border: 13px solid transparent;
        }
        &>div:nth-child(1):before{
            border-top-color:#fff ;
         }
         &>div:nth-child(1):after{
            border-top-color:#c4e2ff ;
         }
        &>div:nth-child(2){
            letter-spacing: 2px;
            line-height: 30px;
            font-size: 14px;
        }
    }
</style>
